import React from "react";

const LOGO_RED = "/static/imagens/logo.png";
const LOGO_WHITE = "/static/imagens/logo_branca.png";

function Logo({ isBlank }) {
  return <img src={isBlank ? LOGO_WHITE : LOGO_RED} alt="Logo da Aplicação" />;
}

export default Logo;
